import { useCheckPhoneNumber } from "@/hooks/query-hooks/useAuth";
import { Button, Form, Input } from "antd";
import { AiOutlinePhone } from "react-icons/ai";

export function AskPhoneNumber({
    handleNextStep
}: {
    handleNextStep: (data: CheckPhoneNumberResponse) => void;
}) {

    const [form] = Form.useForm();

    const { mutate, isMutating } = useCheckPhoneNumber();

    const onFinish = (values: { phone: string }) => {
        mutate(values, {
            onSuccess: (data) => {
                handleNextStep(data)
            }
        })
    }

    return (
        <>
            <article
                className="font-poppins space-y-2"
            >
                <h3
                    className="text-lg font-medium text-center"
                >
                    Forgot Password
                </h3>
                <p className="text-sm text-center text-gray-600">
                    Please enter the phone number associated with your account to reset your password.
                </p>
            </article>
            <Form
                form={form}
                onFinish={onFinish}
                layout="vertical"
            >
                <Form.Item
                    label="Phone Number"
                    name={"phone"}
                    rules={[
                        {
                            required: true, message: "Required!"
                        },
                        {
                            pattern: /^09\d{6,9}$/,
                            message: "Invalid phone number format!"
                        }
                    ]}
                >
                    <Input
                        prefix={
                            <AiOutlinePhone
                                className="mr-2"
                            />
                        }
                        placeholder="Enter your phone number"
                        size="large"
                    />
                </Form.Item>

                <Button
                    block
                    size="large"
                    htmlType="submit"
                    className="bg-primary-gradient !text-white !font-poppins"
                    loading={isMutating}
                >
                    Confirm
                </Button>
            </Form>
        </>
    )
}
